import {
  Component,
  OnInit,
  Input,
  Output,
  ViewChild,
  EventEmitter,
} from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { NzTreeComponent } from "ng-zorro-antd/tree";
import { NzFormatEmitEvent, NzTreeNodeOptions } from "ng-zorro-antd/core";
import {
  FieldWrapper,
  KreFormFieldConfig,
  KreTableFieldConfig,
} from "@kre-form/core";
import * as _ from "lodash";

import { DataService } from "../../service/data.service";

@Component({
  selector: "kreform-fieldbutton",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.less"],
})
export class KreFormFieldButton implements OnInit {
  @Input() field: KreFormFieldConfig = {};

  @Output() buttonClick: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  fieldOperational(e: any) {
    this.buttonClick.emit(e);
  }

  get showDeleteBtn() {
    let result = true;
    if (
      this.field &&
      this.field.templateOptions &&
      this.field.templateOptions != null &&
      this.field.templateOptions.isButintin &&
      this.field.templateOptions.isButintin == true
    ) {
      result = false;
    }
    return result;
  }

  checkField() {
    let result = true;

    if (
      this.field.design != undefined &&
      this.field.design != null &&
      Object.keys(this.field.design).length > 0
    ) {
      result = false;
    }
    return result;
  }

  get ShowEditBtn() {
    return _.get(this.field, "editProperty.config");
  }
}
